export enum NotificationNativeMethods {
  CREATE = 'CREATE',
}
